<script>
import SimpleNav from "@/components/simple-nav";
import Swal from "sweetalert2";
import { AuthService } from '@/services/auth.service'
import { PackageService } from "@/services/nextshop/package.service";
import { removeStorageItem } from '@/utils/auth'
export default {
  name: "package-select",
  components: {
    SimpleNav,
  },
  data() {
    return {
      loading: false,
      inforMerchant: JSON.parse(localStorage.getItem("auth.currentMerchant")),
      selected: 1,
      dataPlan: {},
      isNotIncludeFree: Boolean,
      checkName: true,
      checkPhone: false,
      checkChangePlan: false
    };
  },

  async created() {
    await this.fetchData();
  },
  methods: {
    async fetchData() {
      try {
        this.loading = true;
        const response = await PackageService.checkMerchantHasPlan({
          id: this.inforMerchant.id,
        });
        this.isNotIncludeFree = response.data.totalPlan == 0 ? false : true;
        if (response.success) {
          if (response.data.hasActivePlan) {
            await this.checkPlanRedirect();
          } else {
            this.getActivePlan();
          }
        }
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    async createOrder(validate) {
      validate().then(async (success) => {
        if (!success) {
          const el = document.querySelector(".is-invalid");
          el.focus();
          return;
        } else {
          //
          try {
            this.loading = true;
            const params = {
              merchantInfo: {
                merchantId: this.inforMerchant.id,
                name: this.inforMerchant.name,
                phoneNum: this.inforMerchant.phone,
                email: this.inforMerchant.email,
                location: this.inforMerchant.address,
              },
              paymentStatus: true,
              planId: this.dataPlan[this.selected - 1].id,
              startTime: new Date().toISOString(),
            };
            const response = await PackageService.createOrder(params);
            if (response.success) {
              // msg success

              const customSwal = Swal.mixin({
                customClass: {
                  confirmButton: "btn btn-primary fz-18",
                },
              });
              customSwal
                .fire({
                  imageUrl: require("@/assets/images/icon-nextshop-package.png"),
                  imageHeight: 100,
                  imageAlt: `Icon Nextshop`,
                  title: `<span style="color: #23313E;font-weight: 600;">NextShop đã ghi nhận thông tin</span>`,
                  text: `Chúng tôi sẽ liên lạc với bạn trong thời gian sớm nhất!`,
                  confirmButtonText: "Đồng ý",
                })
                .then(() => {
                  this.$router.push({ path: `/` });
                });
            }
            this.loading = false;
          } catch (error) {
            console.log(error);
          } finally {
            this.loading = false;
          }
        }
      });
    },

    async getActivePlan() {
      try {
        this.loading = true;
        const response = await PackageService.getActivePlan({
          isNotIncludeFree: this.isNotIncludeFree,
        });
        this.dataPlan = response.data.map(r => {
          return {
            ...r,
            typeDay: r.timeUnit === 'DAY' ? 'ngày' : r.timeUnit === 'MONTH' ? 'tháng' : r.timeUnit === 'YEAR' ? 'năm' : ''
          }
        });
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },

    validName() {
      const lengthName = this.inforMerchant.name.length
      lengthName > 0 && lengthName < 256
        ? (this.checkName = true)
        : (this.checkName = false);
    },

    validPhone() {
      this.inforMerchant.phone.length > 0 ||
      this.inforMerchant.phone.length < 16
        ? (this.checkPhone = true)
        : (this.checkPhone = false);
    },
    async merchantPlanConfigs() {
      try {
        const response = await PackageService.merchantPlanConfigs()
        if (response.success) {
          if(response.data.plan == null || response.data.plan == ''){
              removeStorageItem('locationName')
              AuthService.packageBackHome()
          }else{
            this.checkChangePlan = response.data.planChanged
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
    async checkPlanRedirect(){
      const inforUsers = JSON.parse(localStorage.getItem("auth.currentUser"))
      await this.merchantPlanConfigs()
      if(this.checkChangePlan){
        if(inforUsers.role == 'employee'){
          this.$router.push('/forbidden')
        }else{
          this.$router.push('/package-select-v2')
        }
      }else{
        this.$router.push('/dashboard')
      }
    },
    async backHome(){
      removeStorageItem('locationName')
      AuthService.packageBackHome()
    }
  },
};
</script>

<template>
  <div>
    <SimpleNav />
    <div class="container-fluid package-wrapper">
      <div class="row">
        <div class="col-lg-12 mx-auto">
          <div class="page-heading text-white">
            <h1>
              Ra mắt NextShop Pro
              <br />
              Tưng bừng ưu đãi
            </h1>
            <h5 class="text-white">
              Tặng ngay 3 tháng dùng thử miễn phí bắt đầu từ ngày kích hoạt.
            </h5>
          </div>
        </div>
      </div>
      <!-- <div class="row"> -->
      <div class="container">
        <div class="row">
          <div class="col-lg-6 form-option-select">
            <validation-observer
              ref="observerPackage"
              v-slot="{ validate, invalid }"
            >
              <div class="card">
                <div class="card-body shadow">
                  <div class="mb-5">
                    <h1 class="mb-3"><b>Vui lòng nhập đầy đủ thông tin:</b></h1>
                    <div class="form-group">
                      <validation-provider
                        name="Họ tên"
                        rules="required|lBetween:1,255|CHECK_HTML"
                        v-slot="{ errors, valid }"
                      >
                        <b-input-group class="mt-3">
                          <template #prepend>
                            <b-input-group-text
                              class="
                                bdr-none
                                bg-none
                                bd-tl-radius-6px bd-bl-radius-6px
                              "
                              :class="[
                                !errors[0]
                                  ? checkName
                                    ? 'is-valid-icon'
                                    : ''
                                  : 'is-invalid-icon',
                              ]"
                              ><i class="far fa-user text-secondary"></i
                            ></b-input-group-text>
                          </template>

                          <b-form-input
                            class="bdl-none bd-tr-radius-6px bd-br-radius-6px"
                            placeholder="Họ tên"
                            id="formrow-firstname-input"
                            type="text"
                            v-model="inforMerchant.name"
                            :state="errors[0] ? false : valid ? true : null"
                            @change="validName()"
                            @keydown.enter.prevent
                          ></b-form-input>
                          <b-form-invalid-feedback>
                            {{ errors[0] }}
                          </b-form-invalid-feedback>
                        </b-input-group>
                      </validation-provider>

                      <validation-provider
                        name="Sô điện thoại"
                        rules="required|PHONE_NO_3|CHECK_HTML|lBetween:1,15"
                        v-slot="{ errors, valid }"
                      >
                        <b-input-group class="mt-3">
                          <template #prepend>
                            <b-input-group-text
                              class="
                                bdr-none
                                bg-none
                                bd-tl-radius-6px bd-bl-radius-6px
                              "
                              :class="[
                                !errors[0]
                                  ? checkPhone
                                    ? 'is-valid-icon'
                                    : ''
                                  : 'is-invalid-icon',
                              ]"
                              ><i
                                class="
                                  bx bx-phone bx-rotate-270
                                  fz-18
                                  text-secondary
                                "
                              ></i
                            ></b-input-group-text>
                          </template>
                          <b-form-input
                            class="bdl-none bd-tr-radius-6px bd-br-radius-6px"
                            placeholder="Số điện thoại"
                            id="formrow-phone-input"
                            type="text"
                            v-model.trim="inforMerchant.phone"
                            @keydown.enter.prevent
                            @keydown="allowNumbersOnly"
                            @change="validPhone()"
                            :state="errors[0] ? false : valid ? true : null"
                          ></b-form-input>
                          <b-form-invalid-feedback>
                            {{ errors[0] }}
                          </b-form-invalid-feedback>
                        </b-input-group>
                      </validation-provider>
                    </div>
                  </div>

                  <div class="mb-5">
                    <h1 class="mb-3">
                      <b>Chọn một trong các gói dịch vụ dưới đây:</b>
                    </h1>
                    <div class="select">
                      <div
                        class="mb-3"
                        v-for="(plan, index) in dataPlan"
                        :key="index"
                      >
                        <label class="card-radio-label">
                          <div
                            class="input-selected card bd-radius-8px"
                            :class="[
                              selected == index + 1 ? 'check-selected' : '',
                            ]"
                            @click="selected = index + 1"
                          >
                            <div class="row card-body py-0">
                              <b-form-radio
                                v-model="selected"
                                :value="index + 1"
                                class="d-inline col-1 mt-4"
                              ></b-form-radio>
                              <div class="col-6">
                                <h5>
                                  <b>{{ plan.name }}</b>
                                </h5>
                                <b class="text-primary fz-30">
                                  {{ plan.price | formatCurrency }}
                                </b>
                              </div>
                              <div
                                class="col-5 text-right"
                                v-if="!isNotIncludeFree"
                              >
                                <span
                                  class="
                                    badge badge-pill badge-success
                                    mb-2
                                    p-2
                                    fz-14
                                  "
                                >
                                </span>
                                <p class="text-secondary text-bold">
                                  <del>
                                    Giá gốc :{{
                                      plan.originalPrice | formatCurrency
                                    }}
                                  </del>
                                </p>
                              </div>
                            </div>
                          </div>
                        </label>
                      </div>
                    </div>
                  </div>

                  <b-button
                    :variant="
                      !invalid && selected > 0 ? 'primary' : 'secondary'
                    "
                    @click.prevent="
                      !invalid && selected > 0 ? createOrder(validate) : ''
                    "
                    >Đăng ký ngay</b-button
                  >
                  <b-button
                    variant="default"
                    @click="backHome">Về trang chủ</b-button
                  >
                </div>
              </div>
            </validation-observer>
          </div>
          <div class="col-lg-6">
            <span>
              <img src="@/assets/images/phones.png" />
            </span>
          </div>
        </div>
      </div>

      <div class="box-loading" v-if="loading">
        <div class="loading">
          <i class="bx bx-loader-circle bx-spin bx-rotate-90 fz50"></i>
        </div>
      </div>
      <!-- </div> -->
    </div>
  </div>
</template>


<style>
.check-selected {
  display: block;
  /* background: #ecf0fe; */
  border: 1px solid #a7a4a4;
  border-color: #3e69f6 !important;
}
.input-selected {
  /* border-radius: 0.25rem; */
  padding: 1rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.is-invalid-icon {
  border: 1px solid #dc3535 !important;
}
.is-valid-icon {
  border: 1px solid #34c38f !important;
  border-right: none;
}
</style>
